import { animate, group, query, style, transition, trigger } from '@angular/animations';

// Fade Animation
export const toggleCheckAnimation = trigger('toggleCheckAnimation', [
  transition('* => *', [
    group([
      query(
        ':leave',
        [
          style({ opacity: 1, transform: 'scale(1) rotate(0deg)' }),
          animate('600ms', style({ transform: 'scale(.4) rotate(270deg)', opacity: 0 }))
        ],
        { optional: true }
      ),
      query(
        ':enter',
        [
          style({ opacity: 0, transform: 'scale(.4) rotate(-180deg)' }),
          animate('450ms', style({ transform: 'scale(1) rotate(0deg)', opacity: 1 }))
        ],
        { optional: true }
      )
    ])
  ])
]);
